import React from 'react';
import { getConfiguredSocialLinks } from '../../config/socialLinks';
import SocialIcons from './SocialIcons';

/**
 * Public social row. Renders nothing when every URL is unset or invalid.
 */
const FollowUs: React.FC = () => {
  const links = getConfiguredSocialLinks();
  if (links.length === 0) return null;

  return (
    <section className="follow-us" aria-labelledby="follow-us-heading">
      <h2 id="follow-us-heading" className="follow-us__heading">
        Follow Us
      </h2>
      <ul className="follow-us__list">
        {links.map((link) => (
          <li key={link.network}>
            <a
              className="follow-us__link"
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.label}
            >
              <SocialIcons network={link.network} />
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default FollowUs;
